module.exports = __webpack_public_path__ + "img/case_coop_portrait.1c43783a.jpg";